import { useTranslation } from 'react-i18next';
import { TrendingDown, Database, Users, Brain, UserX } from 'lucide-react';

const painIcons = [TrendingDown, Database, Users, Brain, UserX];

export function PainMirrorSection() {
  const { t } = useTranslation();

  const pains = [
    { title: t('landing.pain.card1Title'), desc: t('landing.pain.card1Desc') },
    { title: t('landing.pain.card2Title'), desc: t('landing.pain.card2Desc') },
    { title: t('landing.pain.card3Title'), desc: t('landing.pain.card3Desc') },
    { title: t('landing.pain.card4Title'), desc: t('landing.pain.card4Desc') },
    { title: t('landing.pain.card5Title'), desc: t('landing.pain.card5Desc') },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container">
        <div className="mx-auto max-w-4xl">
          <h2 className="mb-12 text-center text-3xl font-bold tracking-tight text-[#1A1F3C] md:text-4xl">
            {t('landing.pain.headline')}
          </h2>

          <div className="grid gap-4 sm:grid-cols-2">
            {pains.map((pain, index) => {
              const Icon = painIcons[index];
              return (
                <div
                  key={index}
                  className={`rounded-xl border border-[#1A1F3C]/8 bg-[#F4F5FF]/50 p-6 ${
                    index === 4 ? 'sm:col-span-2 sm:max-w-md sm:mx-auto' : ''
                  }`}
                >
                  <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-red-50">
                      <Icon className="h-5 w-5 text-[#EF4444]" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-[#1A1F3C] mb-1">{pain.title}</h3>
                      <p className="text-sm text-[#1A1F3C]/60 leading-relaxed">{pain.desc}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <p className="mt-10 text-center text-lg font-semibold text-[#1A1F3C]">
            {t('landing.pain.closing')}
          </p>
        </div>
      </div>
    </section>
  );
}
